import { Button, Text, VStack } from "@chakra-ui/react";

export const AppErrorFallback = () => (
  <VStack justify="center" align="center" h="100vh" spacing={4} px={4}>
    <Text fontSize="lg" fontWeight="semibold" textAlign="center">
      Algo deu errado
    </Text>
    <Text color="gray.500" textAlign="center" maxW="sm">
      Ocorreu um erro inesperado. A equipe foi notificada automaticamente.
    </Text>
    <Button onClick={() => window.location.reload()} colorScheme="blue" size="sm">
      Recarregar página
    </Button>
  </VStack>
);
